import { Bell } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { fetchUnreadCount } from "../../Store/Actions/NotificationActions";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";

const Header = ({ clases }) => {
  const dispatch = useDispatch();
  const loginSuccess = useSelector((state) => state.auth?.loginSuccess);
  const unreadCount = useSelector(
    (state) => state.notifications?.unreadCount || 0
  );
  const [profilePicture, setProfilePicture] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;
    fetch(`${BASE_URL}${API_ENDPOINTS.GET_USER_DOCUMENTS}?documentType=PROFILE_PICTURE`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .catch(() => null)
      .then((result) => {
        const data = result?.data || result;
        if (Array.isArray(data) && data.length > 0) {
          setProfilePicture(data[0].documentLink);
        }
      });
  }, []);

  // Only re-trigger the pop animation when the count increases
  const [animKey, setAnimKey] = useState(0);
  const prevCountRef = useRef(null);
  useEffect(() => {
    if (prevCountRef.current === null || unreadCount > prevCountRef.current) {
      setAnimKey((k) => k + 1);
    }
    prevCountRef.current = unreadCount;
  }, [unreadCount]);

  // Get username, email and role from login response
  const username = loginSuccess?.data?.username || "User";
  const email = loginSuccess?.data?.email || "";
  const roleName = loginSuccess?.data?.roleName;
  const assistantPermissions = loginSuccess?.data?.assistantPermissions;
  const isAssistant = roleName === "assistant";
  const hasNotifications = !isAssistant || assistantPermissions?.notifications === true;

  useEffect(() => {
    if (!hasNotifications) return;
    dispatch(fetchUnreadCount());
  }, [dispatch, hasNotifications]);

  return (
    <div className="border-b border-border sticky top-0 h-fit bg-white z-50">
      <div
        className={`flex flex-col lg:flex-row lg:justify-between items-center py-7 ${clases}`}
      >
        <div className="text-center lg:text-left">
          <div className="flex items-center gap-2 justify-center lg:justify-start">
            <p className="font-popinsBold text-2xl">Hello {username}</p>
          </div>
          <p className="text-textColor font-popinsRegular text-sm">
            {email || "Let's learn something new today!"}
          </p>
        </div>
        <div className="flex items-center gap-x-10 mt-4 lg:mt-0">
          {hasNotifications && (
            <Link to={"/dashboard/notification"} className="relative">
              <Bell className="text-secondary cursor-pointer text-xl lg:text-3xl" />
              {unreadCount > 0 && (
                <span
                  key={animKey}
                  className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-popinsMedium animate-badge-pop"
                >
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </Link>
          )}
          {isAssistant ? (
            <img
              src={profilePicture || "/assets/images/user-avatar.png"}
              alt=""
              className="rounded-full size-10 lg:size-12 object-cover"
              onError={(e) => { e.target.src = "/assets/images/user-avatar.png"; }}
            />
          ) : (
            <Link to="/dashboard/user-setting">
              <img
                src={profilePicture || "/assets/images/user-avatar.png"}
                alt=""
                className="rounded-full size-10 lg:size-12 cursor-pointer object-cover"
                onError={(e) => { e.target.src = "/assets/images/user-avatar.png"; }}
              />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
